import { MARKDOWN_LINK_REGEX, stripMarkdownLinkFormatting, unescapeMarkdownLinkText, } from '#pplx/frontend/common/markdownTitle.js';
import React from 'react';
// TODO - Try to do better ReactMarkdown; it was difficult to make play
//        it nice with vercel/og (e.g. layout limitations with divs)
// Note: Using [\s:-] instead of [-:\s] to avoid Tailwind JIT scanner
export const MARKDOWN_TABLE_PATTERN = /^\|([^|\n]*\|)+$\n(^\|[\s:-]+\|[\s:-]+$\n)?(^\|([^|\n]*\|)+$\n?)+/m;
// Underscore emphasis should not match inside identifiers like foo_bar.
const UNDERSCORE_BOLD_PATTERN = /(^|[^A-Za-z0-9_])__([^_\s](?:.*?[^_\s])?)__(?=$|[^A-Za-z0-9_])/g;
const UNDERSCORE_ITALIC_PATTERN = /(^|[^A-Za-z0-9_])_([^_\s](?:.*?[^_\s])?)_(?=$|[^A-Za-z0-9_])/g;
export const cleanMarkdown = (markdown, limit = 750) => {
    if (!markdown) {
        return '';
    }
    // Remove headers
    const noHeaders = markdown.replace(/^#{1,6}\s.*$/gm, '');
    // Remove tables
    const noTables = noHeaders.replace(new RegExp(MARKDOWN_TABLE_PATTERN.source, 'gm'), '');
    // Remove common markdown while maintaining text
    const noMarkdown = noTables
        .replace(/\*\*(.*?)\*\*/g, '$1') // Bold
        .replace(UNDERSCORE_BOLD_PATTERN, '$1$2') // Bold
        .replace(/\*(.*?)\*/g, '$1') // Italic
        .replace(UNDERSCORE_ITALIC_PATTERN, '$1$2') // Italic
        .replace(/~~(.*?)~~/g, '$1') // Strikethrough
        .replace(/`(.*?)`/g, '$1') // Inline code
        .replace(/!\[(.*?)\]\(.*?\)/g, '$1') // Images
        .replace(/\[(.*?)\]\(.*?\)/g, '$1') // Links
        .replace(/^\s*[-+*]\s/gm, '') // Unordered lists
        .replace(/^\s*\d+\.\s/gm, '') // Ordered lists
        .replace(/^\s*>\s/gm, '') // Blockquotes
        .replace(/\n{2,}/g, '\n\n'); // Multiple newlines
    // Remove citations
    const noCitations = noMarkdown.replace(/\s*\[\d+\](\[\d+\])*/g, '');
    // Trim
    const trimmed = noCitations.trim();
    return trimmed.slice(0, limit);
};
/**
 * Strips markdown link syntax from a title to show only visible text.
 *
 * @param title - String that may contain markdown links [text](url)
 * @returns Plain text with complete markdown links stripped (just the visible text)
 */
export const getDisplayTitle = (title) => {
    return stripMarkdownLinkFormatting(title);
};
/**
 * Renders a string containing markdown links as React nodes.
 * Parses [text](url) syntax and renders links using the provided callback.
 */
export const linkifyMarkdown = (value, options) => {
    const { displayText, links } = extractMarkdownLinks(value);
    if (links.length === 0)
        return displayText;
    const parts = [];
    let lastOffset = 0;
    for (const [index, link] of links.entries()) {
        if (link.startOffset > lastOffset) {
            parts.push(displayText.substring(lastOffset, link.startOffset));
        }
        parts.push(options.renderLink(link.url, displayText.substring(link.startOffset, link.endOffset), index));
        lastOffset = link.endOffset;
    }
    if (lastOffset < displayText.length) {
        parts.push(displayText.substring(lastOffset));
    }
    return parts;
};
/**
 * Extracts markdown links and returns the display text with link positions.
 * Parses [text](url) and returns their character offsets in the resulting plain text.
 */
const extractMarkdownLinks = (text) => {
    if (!text) {
        return { displayText: '', links: [] };
    }
    const links = [];
    let displayText = '';
    let lastIndex = 0;
    let currentOffset = 0;
    let match;
    const linkRegex = new RegExp(MARKDOWN_LINK_REGEX);
    while ((match = linkRegex.exec(text)) !== null) {
        const linkText = match[1] ? unescapeMarkdownLinkText(match[1]) : undefined;
        const url = match[2];
        const matchStart = match.index;
        displayText += text.substring(lastIndex, matchStart);
        currentOffset += matchStart - lastIndex;
        if (linkText) {
            const startOffset = currentOffset;
            displayText += linkText;
            currentOffset += linkText.length;
            const endOffset = currentOffset;
            if (url) {
                links.push({ url, startOffset, endOffset });
            }
        }
        lastIndex = linkRegex.lastIndex;
    }
    displayText += text.substring(lastIndex);
    return { displayText, links };
};
//# sourceMappingURL=markdown.js.map